import { compact } from 'lodash';
import { useMemo } from 'react';

import {
   createDynamicColumnsWidth,
   InteractiveTable,
   InteractiveTableColumnConfiguration,
} from '@dreryk/react-components';

import { generalSettingsTranslationKeys } from '../../../../../translations';

import { SurveyPreInterviewTemplateTableBean } from './SurveyPreInterviewTemplateInteractiveTable.types';
import { QuestionContentCell } from './cells/QuestionContentCell';

type UseSurveyPreInterviewTemplateInteractiveTableColumnsOptions = {
   editMode: boolean;
};

export const useSurveyPreInterviewTemplateInteractiveTableColumns = (
   options: UseSurveyPreInterviewTemplateInteractiveTableColumnsOptions
): InteractiveTableColumnConfiguration<SurveyPreInterviewTemplateTableBean>[] => {
   return useMemo(() => {
      const columnsWidth = createDynamicColumnsWidth({
         ordinalNumber: '50px',
         content: '100%',
         options: '24px',
      });

      return compact([
         {
            name: 'ordinalNumber',
            label: generalSettingsTranslationKeys.survey.preInterview.form.interactiveTable.ordinalNumber,
            width: columnsWidth.ordinalNumber,
            renderer: ({ index }) => {
               return <InteractiveTable.OrdinalNumberCell index={index} testId={'ordinalNumber'} />;
            },
         },
         {
            name: 'content',
            label: generalSettingsTranslationKeys.survey.preInterview.form.interactiveTable.questionContent,
            width: columnsWidth.content,
            renderer: ({ bean, index }) => {
               if (options.editMode) {
                  return (
                     <QuestionContentCell
                        name={'content'}
                        testId={'content'}
                        defaultValue={bean.content}
                        index={index}
                     />
                  );
               }

               return (
                  <InteractiveTable.TextViewCell
                     defaultValue={bean.content}
                     index={index}
                     name={'content'}
                     testId={'content'}
                  />
               );
            },
         },
         {
            name: 'options',
            width: columnsWidth.options,
            renderer: ({ index, rowsCount }) => {
               return options.editMode ? (
                  <InteractiveTable.DeleteRowCell index={index} disabled={rowsCount <= 1} />
               ) : null;
            },
         },
      ]);
   }, [options.editMode]);
};
